import apiClient from "../../service/apiClient";
import {
  GetStateByCountryIdAndAbbrRequest,
  GetStateByCountryIdRequest,
  GetStatesRequest,
} from "../models/request/get-states-request";
import {
  GetStatesResponse,
  State,
} from "../models/response/get-states-response";

export async function getStateByCountryId(
  request: GetStateByCountryIdRequest
): Promise<GetStatesResponse> {
  const response = await apiClient.get<GetStatesResponse>(
    `/states/country/${request.countryId}`,
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        searchQuery: request.searchQuery,
      },
    }
  );

  return response.data;
}

export async function getPaginatedStates(
  request: GetStatesRequest
): Promise<GetStatesResponse> {
  const response = await apiClient.get<GetStatesResponse>("/states", {
    params: {
      page: request.page,
      perPage: request.perPage,
    },
  });
  return response.data;
}

export async function getPaginatedByNameStates(
  request: GetStatesRequest
): Promise<GetStatesResponse> {
  const response = await apiClient.get<GetStatesResponse>(
    "/states/search-by-name",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        searchQuery: request.searchQuery,
        countryId: request.countryId,
      },
    }
  );
  return response.data;
}

export async function getStateByCountryIdAndAbbr(
  request: GetStateByCountryIdAndAbbrRequest
): Promise<State> {
  const response = await apiClient.get<State>(
    `/states/country/${request.countryId}/abbr/${request.abbr}`,
    {
      params: {
        countryId: request.countryId,
        abbr: request.abbr,
      },
    }
  );

  return response.data;
}
